import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'pcln-design-system'

export default function BaggageFeesLink({ onClick, className }) {
  return (
    <Link
      href='https://www.priceline.com/help-page/submenu/241/261/baggage-fees-and-carry-on-limits'
      target='_blank'
      onClick={onClick}
      className={className}
    >
      Baggage Fees
    </Link>
  )
}

BaggageFeesLink.defaultProps = {
  onClick: () => {},
}

BaggageFeesLink.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
}
